import { render } from "./DistrictFormBlock.vue?vue&type=template&id=45e1c62f"
import script from "./DistrictFormBlock.vue?vue&type=script&lang=js"
export * from "./DistrictFormBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__